// source: icws_proto/icws_api_gateway/updating/base.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var icws_proto_icws_api_gateway_storage_base_pb = require('../../../icws_proto/icws_api_gateway/storage/base_pb.js');
goog.object.extend(proto, icws_proto_icws_api_gateway_storage_base_pb);
goog.exportSymbol('proto.InkCapture.UpdatedProcessedScan', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InkCapture.UpdatedProcessedScan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.InkCapture.UpdatedProcessedScan.repeatedFields_, null);
};
goog.inherits(proto.InkCapture.UpdatedProcessedScan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InkCapture.UpdatedProcessedScan.displayName = 'proto.InkCapture.UpdatedProcessedScan';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.InkCapture.UpdatedProcessedScan.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InkCapture.UpdatedProcessedScan.prototype.toObject = function(opt_includeInstance) {
  return proto.InkCapture.UpdatedProcessedScan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InkCapture.UpdatedProcessedScan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.UpdatedProcessedScan.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    blocksList: jspb.Message.toObjectList(msg.getBlocksList(),
    icws_proto_icws_api_gateway_storage_base_pb.Block.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InkCapture.UpdatedProcessedScan}
 */
proto.InkCapture.UpdatedProcessedScan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InkCapture.UpdatedProcessedScan;
  return proto.InkCapture.UpdatedProcessedScan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InkCapture.UpdatedProcessedScan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InkCapture.UpdatedProcessedScan}
 */
proto.InkCapture.UpdatedProcessedScan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new icws_proto_icws_api_gateway_storage_base_pb.Block;
      reader.readMessage(value,icws_proto_icws_api_gateway_storage_base_pb.Block.deserializeBinaryFromReader);
      msg.addBlocks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InkCapture.UpdatedProcessedScan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InkCapture.UpdatedProcessedScan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InkCapture.UpdatedProcessedScan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.UpdatedProcessedScan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      icws_proto_icws_api_gateway_storage_base_pb.Block.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.InkCapture.UpdatedProcessedScan.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.UpdatedProcessedScan} returns this
 */
proto.InkCapture.UpdatedProcessedScan.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Block blocks = 2;
 * @return {!Array<!proto.InkCapture.Block>}
 */
proto.InkCapture.UpdatedProcessedScan.prototype.getBlocksList = function() {
  return /** @type{!Array<!proto.InkCapture.Block>} */ (
    jspb.Message.getRepeatedWrapperField(this, icws_proto_icws_api_gateway_storage_base_pb.Block, 2));
};


/**
 * @param {!Array<!proto.InkCapture.Block>} value
 * @return {!proto.InkCapture.UpdatedProcessedScan} returns this
*/
proto.InkCapture.UpdatedProcessedScan.prototype.setBlocksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.InkCapture.Block=} opt_value
 * @param {number=} opt_index
 * @return {!proto.InkCapture.Block}
 */
proto.InkCapture.UpdatedProcessedScan.prototype.addBlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.InkCapture.Block, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.InkCapture.UpdatedProcessedScan} returns this
 */
proto.InkCapture.UpdatedProcessedScan.prototype.clearBlocksList = function() {
  return this.setBlocksList([]);
};


goog.object.extend(exports, proto.InkCapture);
